/**
 * Product PDP floating back + cart badge (App mobile chrome).
 */
(function (global) {
  const root = global.document;
  if (!root) return;

  function updateBadge(count) {
    const badge = root.querySelector('[data-offhoo-pdp-cart-badge]');
    const label = root.querySelector('[data-offhoo-pdp-cart-label]');
    if (!badge) return;

    const n = Math.max(0, Number(count) || 0);
    badge.textContent = n > 99 ? '99+' : String(n);
    badge.classList.toggle('is-empty', n === 0);

    if (label) {
      const prefix = (global.Theme && global.Theme.translations && global.Theme.translations.cart_count) || 'Cart';
      label.textContent = `${prefix}: ${n}`;
    }
  }

  function bindBack() {
    const back = root.querySelector('[data-offhoo-pdp-back]');
    if (!back || back.dataset.offhooPdpBackReady === 'true') return;
    back.dataset.offhooPdpBackReady = 'true';

    back.addEventListener('click', (event) => {
      event.preventDefault();
      if (global.history.length > 1) {
        global.history.back();
        return;
      }
      global.location.href = (global.Theme && global.Theme.routes && global.Theme.routes.root_url) || '/';
    });
  }

  function bindCartBadge() {
    // Must match Shopify StandardEvents.cartLinesUpdate / offhoo-app.js
    const CART_LINES_UPDATE = 'shopify:cart:lines-update';

    global.document.addEventListener(CART_LINES_UPDATE, (event) => {
      event?.promise
        ?.then(({ cart, detail }) => {
          const itemCount = cart?.totalQuantity ?? detail?.itemCount ?? 0;
          updateBadge(itemCount);
          if (global.OffhooAppConfig) {
            global.OffhooAppConfig.cartItemCount = itemCount;
          }
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') {
            console.warn('[offhoo-pdp-floating-nav] cart badge update failed:', error);
          }
        });
    });

    global.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      const cfg = global.OffhooAppConfig;
      if (cfg && cfg.cartItemCount != null) updateBadge(cfg.cartItemCount);
    });
  }

  function boot() {
    if (!root.querySelector('[data-offhoo-pdp-floating-nav]')) return;
    bindBack();
    bindCartBadge();
  }

  if (root.readyState === 'loading') {
    root.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(typeof window !== 'undefined' ? window : globalThis);
